export default __webpack_public_path__ + "static/media/a14.cc85fc12.webp";